class SortBy extends HTMLElement {
  connectedCallback() {
    this.defaultSortBy = this.getAttribute('data-sort-by-default');
    this.dropdownId = this.getAttribute('data-dropdown-id');
    this.dropdown = document.getElementById(this.dropdownId);
    this.button = this.querySelector('[data-dropdown-controller]');
    
    // Check if required elements exist
    if (!this.dropdown || !this.button) {
      return;
    }
    
    this.currentValue = this.getCurrentValue();
    
    // Add click listeners to dropdown options
    this.querySelectorAll('[data-value]').forEach(option => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        const value = option.getAttribute('data-value');
        this.handleSelection(value);
      });
    });
  }

  /**
   * Get current sort value from selected option
   */
  getCurrentValue() {
    const selectedOption = this.querySelector('[aria-selected="true"]');
    return selectedOption ? selectedOption.getAttribute('data-value') : this.defaultSortBy;
  }

  /**
   * Handle option selection
   * @param {String} value - Selected sort value
   */
  handleSelection(value) {
    if (value === this.currentValue) {
      this.dropdown?.close();
      return;
    }

    this.currentValue = value;
    this.updateSortElements(value);
    this.dropdown?.close();
  }

  /**
   * Update sort elements
   * @param {String} value - Sort value
   *
   * @description Update all collection sort elements when the sort is changed
   */
  updateSortElements(value) {
    this.sortElements = this.sortElements || document.querySelectorAll('sort-by');

    // Update all sort-by elements on the page
    this.sortElements.forEach((element) => {
      element.updateDisplay(value);
      element.updateURL(value);
    });

    publish('sort:changed', {
      value,
    });
  }

  /**
   * Update the display of the sort-by element
   * @param {String} value - Sort value
   */
  updateDisplay(value) {
    // Update button label
    const label = this.querySelector('.sort-by__label');
    const selectedOption = this.querySelector(`[data-value="${value}"]`);
    if (label && selectedOption) {
      label.textContent = selectedOption.querySelector('span').textContent;
    }

    // Update selected states
    this.querySelectorAll('[data-value]').forEach(option => {
      const isSelected = option.getAttribute('data-value') === value;
      option.classList.toggle('bg-gray-50', isSelected);
      option.classList.toggle('font-medium', isSelected);
      option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      
      // Update check icon
      const checkIcon = option.querySelector('.icon');
      if (isSelected && !checkIcon) {
        option.insertAdjacentHTML('beforeend', '<svg class="icon w-4 h-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>');
      } else if (!isSelected && checkIcon) {
        checkIcon.remove();
      }
    });
  }

  /**
   * Update URL
   * @param {String} value - URL value
   */
  updateURL(value) {
    const { searchParams } = new URL(window.location);
    searchParams.set('sort_by', value);
    searchParams.delete('page');

    // if value = default, remove the sort_by parameter from the URL
    if (this.defaultSortBy && value === this.defaultSortBy) {
      searchParams.delete('sort_by');
    }

    const newUrl = searchParams.size
      ? `${window.location.pathname}?${searchParams}`
      : window.location.pathname;
    history.replaceState(null, '', newUrl);
  }
}

customElements.define('sort-by', SortBy);
